import styled from "styled-components";
import { useWindowSize } from "../../hook/useWindowSize";
import CloseIcon from "../Icons/CloseIcon";
import CloseIconMb from "../Icons/CloseIconMb";
import * as Style from "./Modal.styles";

export default function Modal({ children, ...props }) {
  return <Style.Modal {...props}>{children}</Style.Modal>;
}

Modal.ModalBg = function ModalBg({ children, ...props }) {
  const size = useWindowSize();
  const isMobile = size.width < 1024;
  return (
    <Style.ModalBg {...props} onClick={() => props?.onClose()}>
      {/* {!isMobile && (
        <Style.CloseIcon onClick={() => props?.onClose()}>
          <CloseIcon color={"#ffffff"} />
        </Style.CloseIcon>
      )} */}
      {children}
    </Style.ModalBg>
  );
};

Modal.ModalBg2 = function ModalBg({ children, ...props }) {
  return (
    <Style.ModalBg {...props} onClick={() => props?.onClose()}>
      {children}
    </Style.ModalBg>
  );
};

Modal.ContentWraper = styled.div`
  max-height: 80vh;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
`;

// Modal.Container = function ModalConainer({ children, ...props }) {
//   const size = useWindowSize();
//   const isMobile = size.width < 1024;

//   return (
//     <Style.Container {...props}>
//       {children}
//       {isMobile && (
//         <Style.CloseIcon onClick={() => props?.onClose()}>
//           <CloseIconMb />
//         </Style.CloseIcon>
//       )}
//     </Style.Container>
//   );
// };
Modal.Container = function ModalConainer({ children, ...props }) {
  return (
    <Style.Container {...props}>
      {children}
      <Style.CloseIcon onClick={() => props?.onClose()}>
        <CloseIconMb />
      </Style.CloseIcon>
    </Style.Container>
  );
};
Modal.Container2 = function ModalConainer({ children, ...props }) {
  return (
    <Style.Container {...props}>
      {children}
      <Style.CloseIcon onClick={() => props?.onClose()}>
        <CloseIconMb />
      </Style.CloseIcon>
    </Style.Container>
  );
};
Modal.Header = function ModalHeader({ children, ...props }) {
  return <Style.Header {...props}>{children}</Style.Header>;
};

Modal.Body = function ModalBody({ children, ...props }) {
  return <Style.Body {...props}>{children}</Style.Body>;
};

Modal.Footer = function ModalFooter({ children, ...props }) {
  return <Style.Footer {...props}>{children}</Style.Footer>;
};

Modal.Label = function ModalLabel({ children, ...props }) {
  return <Style.Label>{children}</Style.Label>;
};

Modal.Input = function ModalInput({ children, ...props }) {
  return <Style.ModalInput {...props} />;
};
